module.exports = __webpack_public_path__ + "static/media/logo-text-blue.61356912.svg";